<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2>Need a call back?</h2>
                <p>Enter your details, our experts will get back to you shortly</p>
                <form>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="input_star">
                                <input type="text" class="form-control" :class="nameError ? 'is-invalid' : ''"
                                    placeholder="Name" v-model="name" />
                            </div>
                            <small class="text-danger d-block text-left" role="alert" v-if="nameError">
                                <strong>{{ nameErrorMessage }}</strong>
                            </small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="input_star">
                                <input type="text" class="form-control" :class="phoneError ? 'is-invalid' : ''"
                                    placeholder="Phone Number (10 digits only)" v-mask="'###-###-####'"
                                    v-model="phone" />
                            </div>
                            <small class="text-danger d-block text-left" role="alert" v-if="phoneError">
                                <strong>{{ phoneErrorMessage }}</strong>
                            </small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="input_star">
                                <input type="email" class="form-control" :class="emailError ? 'is-invalid' : ''"
                                    placeholder="Email" v-model="email" />
                            </div>
                            <small class="text-danger d-block text-left" role="alert" v-if="emailError">
                                <strong>{{ emailErrorMessage }}</strong>
                            </small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <!-- <div class="input-group date" id="datepicker">
                            <input type="date" class="form-control" placeholder="Date" id="date" required />
                        </div> -->
                            <div class="input_star">
                                <input type="date" class="form-control" v-model="date" />
                            </div>
                            <small class="text-danger d-block text-left" role="alert" v-if="dateError">
                                <strong>{{ dateErrorMessage }}</strong>
                            </small>
                        </div>
                        <div class="col-lg-6">
                            <!-- <div class="input-group date" id="timePicker">
                            <input type="time" id="time" class="form-control" placeholder="time" required />
                        </div> -->
                            <div class="input_star">
                                <input type="time" class="form-control" v-model="time" />
                            </div>
                            <small class="text-danger d-block text-left" role="alert" v-if="timeError">
                                <strong>{{ timeErrorMessage }}</strong>
                            </small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <button type="button" class="Schedule_button btn"
                                @click.prevent="scheduleAppointment" :disabled="processing"
                                :style="processing ? 'opacity:0.6;cursor:not-allowed;' : ''">{{ processing ? "Processing..." : "Schedule" }}
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="formSubmitted">
                        <div class="col-lg-12">
                            <div class="alert" :class="responseClass" role="alert">
                                {{ responseMessage }}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  name: "NeedCallbackRequest",
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      date: "",
      time: "",
      processing: false,
      responseClass: "alert-light",
      responseMessage: "",
      formSubmitted: false
    };
  },
  methods: {
    scheduleAppointment() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.processing = true;
        const formData = new FormData();
        formData.append("lead_type", 'contact_us');
        formData.append("name", this.name);
        formData.append("phone", this.phone);
        formData.append("email", this.email);
        formData.append("date", this.date);
        formData.append("time", this.time);
        formData.append("message", 'Callback Request');
        axios
          .post("/submit-callback-request", formData)
          .then(response => {
            let msg = "Successfully scheduled appointment!";
            if (response?.data?.message) {
              msg = response.data.message;
            }
            this.responseMessage = msg;
            this.responseClass = "alert-success";
            this.$v.$reset();
            this.time = "";
            this.date = "";
            this.name = "";
            this.email = "";
            this.phone = "";
          })
          .catch(error => {
            let msg = "Unable to schedule appointment!";
            this.responseClass = "alert-danger";
            if (error?.response?.data?.message) {
              msg = error.response.data.message;
            }
            this.responseMessage = msg;
          }).finally(res => {
            this.processing = false;
            this.formSubmitted = true;
            setTimeout(() => {
              this.formSubmitted = false;
              this.responseClass = "alert-light";
              this.responseMessage = "";
            }, 5000);
          });
      }
    }
  },
  validations: {
    time: {
      required
    },
    date: {
      required
    },
    name: {
      required
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      minLength: minLength(12)
    }
  },
  computed: {
    timeError() {
      if (this.$v.time.$error) {
        return true;
      } else {
        return false;
      }
    },
    timeErrorMessage() {
      if (this.$v.time.$error) {
        return "Select a valid time";
      } else {
        return "";
      }
    },
    dateError() {
      if (this.$v.date.$error) {
        return true;
      } else {
        return false;
      }
    },
    dateErrorMessage() {
      if (this.$v.date.$error) {
        return "Select a valid date";
      } else {
        return "";
      }
    },
    nameError() {
      if (this.$v.name.$error) {
        return true;
      } else {
        return false;
      }
    },
    nameErrorMessage() {
      if (this.$v.name.$error) {
        return "Name is required";
      } else {
        return "";
      }
    },
    phoneError() {
      if (this.$v.phone.$error) {
        return true;
      } else {
        return false;
      }
    },
    phoneErrorMessage() {
      if (this.$v.phone.$error) {
        if (!this.$v.phone.required) {
          return "Phone number is required";
        } else if (!this.$v.phone.minLength) {
          return "Phone number should be 10 digits";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    emailError() {
      if (this.$v.email.$error) {
        return true;
      } else {
        return false;
      }
    },
    emailErrorMessage() {
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return "Email is required";
        } else if (!this.$v.email.email) {
          return "Please enter a valid email address";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  }
}
</script>

<style>
.Schedule_button{
  background: #E11F26;
  color: white;
}
.Schedule_button:hover{
    background: white !important;
    color:#E11F26 !important;
}
</style>
